<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="11"/>
    <div class="numchange">
      <img src="../../assets/images/banners1.jpg" alt="工业品采购" style="width: 100%;">
    </div>

    <div class="Docking">
      <h2>数字化对接解决方案</h2>
      <span>Digital Docking Solution</span>
      <img src="../../assets/images/solution_2_05.png" alt="采购流程" style="width: 1200px;">
      <em>缩短供应链货期、确保正品行货、降低采购成本、保障服务质量</em>
    </div>
    <div class="Platfor">
      <h2>一站式智能采购服务平台</h2>
      <span>One-stop Intelligent Purchasing Service Platfor</span>
      <div class="w1200">
        <ul>
          <li class="gypcg">
            <img src="../../assets/images/xj_icon1.png" alt="工业品采购">
            <span>工业品采购</span>
          </li>
          <li class="sp">
            <img src="../../assets/images/xj_icon2.png" alt="审批">
            <span>审批</span>
          </li>
          <li class="wl">
            <img src="../../assets/images/xj_icon3.png" alt="物流">
            <span>物流</span>
          </li>
          <li class="js">
            <img src="../../assets/images/xj_icon4.png" alt="结算">
            <span>结算</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="Solutions">
      <h2>我们的解决方案</h2>
      <span>Our Solutions</span>
      <ul>
        <li>
          <img src="../../assets/images/xj_img5.jpg" alt="梳理产品、统一标准">
          <div>
            <span>01.梳理产品、统一标准</span>
            <em>
              梳理产品名称、规格、型号等产品清单，统一产品标准化，通过一站式的集采平台满足客户工业品采购的便捷体验。
            </em>
          </div>
        </li>
        <li class="ygcg">
          <img src="../../assets/images/xj_img6.jpg" alt="阳光采购、价格透明">
          <div>
            <span>02.阳光采购、价格透明</span>
            <em>
              合作企业实现专属协议折扣价格，线上价格阳光透明便于查看及采购，为企业提供有效降本解决方案。
            </em>
          </div>
        </li>
        <li class="jhlc">
          <img src="../../assets/images/xj_img7.jpg" alt="简化流程、提升效率">
          <div>
            <span>03.简化流程、提升效率</span>
            <em>
              实现流程可控且规范化管理，简化流程大幅提升审批效率，从而大幅降低企业容易忽视的隐形流程成本。
            </em>
          </div>
        </li>
        <li class="bbtj">
          <img src="../../assets/images/xj_img8.jpg" alt="报表统计、数据分析">
          <div>
            <span>04.报表统计、数据分析</span>
            <em>
              订单数据及汇总报表分析等功能，提高管理效率，多维度数据分析，为管理人员实时监控采购数据提供高效工具。
            </em>
          </div>
        </li>
      </ul>
    </div>
    <!-- 我们的解决方案 -->
    <div class="Provide">
      <div class="Provide-top"></div>
      <div class="w1200">
        <h3>行业专家提供产品选择、技术咨询、订单执行、发票开具、售后维权等全流程跟踪</h3>
        <i>Provide product selection, technical consultation, order execution, invoicing, and after-sales rights protection</i>
        <img src="../../assets/images/xj_icon5.png" alt="">
        <span>行业专家提供产品选择、技术咨询、订单执行、发票开具、售后维权等全流程跟踪，确保采购过程中的问题快速解决。<br>
        同时进一步打通供需上下游，重新梳理公司相关业务，<br>
        降低了管理成本，提高了公司自身的供应链效率，通过自营供应链、搭建服务网络为终端企业客户提供优质高性价比的产品与贴身便捷的服务。</span>
      </div>
    </div>
    <div class="industrial">
      <ul>
        <li><img src="../../assets/images/xj_img9.jpg" alt=""></li>
        <li>
          <h3 style="font-size: 28px;color: #07357b;margin: 0 25px 0 45px;">提高采购效率，优化产业结构</h3>
          <span style="font-size: 15px;font-weight: normal;color: #333333;line-height: 2;margin: 0 25px 0 45px;display: block;margin-top: 20px;">提供线上线下咨询，实现工业品流通的“线上与线下”对接，改变消费模式，从传统的2B和2C模式转变为移动互联网模式，打造MRO供应链平台，链接品牌商和客户，从产品、价格、物流、服务、数据等方面帮助上下游提升采购效率，优化传统产业结构。</span>
        </li>
      </ul>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'Digital',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      qyloading: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
  .atpresent_title{
    font-weight: 600;
  }
  .Docking {
    height: auto !important;
  }
  .Docking em {
    margin-bottom: 20px;
  }
  .numchange {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/view/about/digital.vue